<div class="position-relative h-100">
  @if (canNavigate) {
    <button class="left" type="button" (click)="clickLeft()"></button>
  }
  @if (canNavigate) {
    <button class="right" type="button" (click)="clickRight()"></button>
  }
  @if (currentItem) {
    <div class="slide-area">
      <img [src]="currentItem.url" [title]="currentItem.title" />
    </div>
  }
</div>
